import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.15625 1.71875V6.09375H11.5312C11.8867 6.09375 12.1875 6.39453 12.1875 6.75C12.1875 7.13281 11.8867 7.40625 11.5312 7.40625H7.15625V11.7812C7.15625 12.1641 6.85547 12.4375 6.5 12.4375C6.11719 12.4375 5.84375 12.1641 5.84375 11.7812V7.40625H1.46875C1.08594 7.40625 0.8125 7.13281 0.8125 6.75C0.8125 6.39453 1.08594 6.09375 1.46875 6.09375H5.84375V1.71875C5.84375 1.36328 6.11719 1.0625 6.5 1.0625C6.85547 1.0625 7.15625 1.36328 7.15625 1.71875Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconPlus);
export { ForwardRef as ReactComponent };
